<template>
    <!-- Navbar -->
    <nav class="main-header navbar navbar-expand navbar-white navbar-light">
        <!-- Left navbar links -->
        <ul class="navbar-nav">
            <li class="nav-item">
                <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
            </li>

        </ul>
        <!-- Right navbar links -->
        <ul class="navbar-nav ml-auto">
            <li class="nav-item">
                <a class="nav-link" data-widget="fullscreen" href="#" role="button">
                    <i class="fas fa-expand-arrows-alt"></i>
                </a>
            </li>           
            <li class="nav-item">
                <a class="nav-link text-secondary"   role="button">
                    <i class="">{{ storeAut.getEmail }}</i>
                </a>
            </li>
            <li class="nav-item">
            <a class="nav-link" href="#" v-on:click="closeSession" title="Close Session"> <i class="fas fa-sign-out-alt text-primary"></i></a>
           </li>
            
        </ul>
    </nav>
    <!-- /.navbar -->
</template>

<script lang="ts"  setup>
    import { useRouter   }      from 'vue-router'
    import { useAuthorization } from '@/stores/AuthorizationStore';
    import messages             from '@/core/composable/useMessages';
    
    const storeAut = useAuthorization();
    const router   = useRouter();
    const { sendParameters } = messages()
    
const closeSession=()=>{
    let dto="";
    const promesa = sendParameters("question", "are you sure to log out",dto , 1, '',);
                if (promesa instanceof Promise) {
                    promesa.then(response => {
                        if (response) {  
                            storeAut.destroyerSesion();
                            if(storeAut.getStatusLogin==false){
                                router.push({ name: 'Login'})
                            }
                        }
                    });
                }
}


</script>